export default __webpack_public_path__ + "static/media/detailbanner.gif.46d7fd6b.png";